import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Keycloak from './../node_modules/keycloak-js/lib/keycloak.js'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import './assets/scss/custom.scss'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueLodash, { lodash: lodash })

let initOptions = {
  url: process.env.VUE_APP_KEYCLOAK_URL || "http://localhost:8082/auth",
  realm: process.env.VUE_APP_KEYCLOAK_REALM || 'Recuperator',
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID || 'RecuperatorVuejs',
}

const keycloak = new Keycloak(initOptions);
keycloak.init({
  onLoad: 'login-required',
  redirectUri: process.env.VUE_APP_REDIRECT_URI,
  checkLoginIframe: false,
}).then((auth) => {
  if (!auth) {
    window.location.reload();
    console.error("Not Authenticated");
  } else {
    console.log("Authenticated");
  }
  window.keycloak = keycloak;
  localStorage.setItem("vue-token", keycloak.token);
  localStorage.setItem("vue-refresh-token", keycloak.refreshToken);
  new Vue({
    router,
    store,
    render: h => h(App, { props: {keycloak}} )
  }).$mount('#app')
  setInterval(() => {
    keycloak.updateToken(70).then((refreshed) => {
      // console.log(keycloak.token);
      if (refreshed) {
        localStorage.setItem("vue-token", keycloak.token);
        localStorage.setItem("vue-refresh-token", keycloak.refreshToken);
      } else {
        console.log('Token not refreshed, valid for '
          + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
      }
    }).catch(() => {
      console.error('Failed to refresh token');
    });


  }, 60000)
}).catch(err => {
  console.log(err);
}) 



keycloak.onReady = () => {
  console.log("Keycloak is ready");
};

keycloak.onAuthSuccess = () => {
  console.log("Keycloak authentication successful");
};

keycloak.onAuthError = () => {
  console.error("Keycloak authentication error");
};

// const initKeyCloak = async () => {
//   try {
//     await keycloak.init({
//       checkLoginIframe: false
//     });
//   }
//   catch (error) {
//     console.error("Keycloak initialization failed", error);
//     return;
//   }
// }

// initKeyCloak()

// let keycloak = new Keycloak.Keycloak(initOptions);
// keycloak.init({
//   onLoad: 'login-required'
// })